import React from 'react';
import styled from 'styled-components';
import { Card } from 'antd';
import { slugifyText } from 'logic/slugify-text/slugify-text';
import { translate, translationKeys } from 'logic/translations/translations.service';
import Meta from 'antd/es/card/Meta';

const NearbyPlacesWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  padding-top: 12px;
`;
const Place = styled.a`
  flex: 1 1 315px;
  width: 0;
  max-width: 540px;
`;

const SectionTitle = styled.div`
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 40px;
`;

const CoverImage = styled.img`
  width: 100%;
  height: 100%;
`;

export const NearbyPlaces = ({
  places,
  city,
  numberOfCitiesToShow = 9,
  title = translate(translationKeys.searchResultsPage.common.nearbyCities),
  fallbackImage = 'marburg',
}: {
  places?: { place: string }[];
  city?: string;
  numberOfCitiesToShow?: number;
  title?: string;
  fallbackImage?: string;
}): JSX.Element => {
  const filteredPlaces = places?.filter((place) => slugifyText(city) !== slugifyText(place.place));
  const sectionOfFilteredPlaces =
    numberOfCitiesToShow == null ? filteredPlaces : filteredPlaces?.slice(0, numberOfCitiesToShow);

  return (
    <>
      <SectionTitle>{title}</SectionTitle>
      <NearbyPlacesWrapper>
        {sectionOfFilteredPlaces?.map(({ place }, i) => (
          <Place key={i} href={`/${slugifyText(place)}/nachhilfe`}>
            <Card
              cover={
                <CoverImage
                  alt={translate(translationKeys.searchResultsPage.nearbyPlaces.title, { place })}
                  src={`/images/nearby-places/${slugifyText(place)}.jpg`}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = `/images/nearby-places/${fallbackImage}.jpg`;
                  }}
                  width="180"
                  height="70"
                />
              }
            >
              <Meta
                style={{ lineHeight: '3ex', minHeight: '3ex' }}
                title={translate(translationKeys.searchResultsPage.nearbyPlaces.title, { place })}
              />
            </Card>
          </Place>
        ))}
      </NearbyPlacesWrapper>
    </>
  );
};
